import PhotoGallery from '../components/PhotoGallery';

const Photos = () => (
  <div className="container mx-auto p-8">
    <h2 className="text-3xl font-bold mb-4">Photo Gallery</h2>
    <PhotoGallery />
  </div>
);

export default Photos;
